module["exports"] = [
  "com",
  "ru",
  "info",
  "рф",
  "net",
  "org"
];
